import { Controller } from "@hotwired/stimulus"

const SHOWN_KEY = "lifSplashShown"
const JUST_LOGGED_OUT_KEY = "lifJustLoggedOut"

export default class extends Controller {
  static targets = ["logo"]
  static values = { duration: { type: Number, default: 8000 } }

  connect() {
    const alreadyShown = sessionStorage.getItem(SHOWN_KEY)
    const justLoggedOut = sessionStorage.getItem(JUST_LOGGED_OUT_KEY)

    if (alreadyShown && !justLoggedOut) {
      this.element.remove()
      return
    }

    sessionStorage.setItem(SHOWN_KEY, "1")
    sessionStorage.removeItem(JUST_LOGGED_OUT_KEY)

    document.body.classList.add("overflow-hidden")

    requestAnimationFrame(() => {
      this.logoTarget.classList.remove("opacity-0", "scale-90")
    })

    this.timeout = setTimeout(() => this.dismiss(), this.durationValue)
  }

  dismiss() {
    this.element.classList.add("opacity-0", "pointer-events-none")
    document.body.classList.remove("overflow-hidden")
    this.element.addEventListener("transitionend", () => this.element.remove(), { once: true })
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
